<template>
  <div class="degrade-background-sebrae header">
    <div class="sebrae">
      <img
        style="width: 70px"
        src="https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
      />
    </div>
    <div class="header-title">FORMULÁRIO DE INSCRIÇÃO - {{ title }}</div>
    <div class="cardAqui">
      <div class="medalhas">
        <img
          src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaBronze.png"
        />
        <img
          src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaPrata.png"
        />
        <img
          src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaOuro.png"
        />
        <img
          src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaDiamante.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headerFormulario",
  data() {
    return {
      title: this.getTitle(),
    };
  },
  methods: {
    getTitle() {
      if (window.location.href.includes("formularios/sala-empreendedor"))
        return "SALA DO EMPREENDEDOR";
      if (window.location.href.includes("formularios/parceiro"))
        return "PARCEIRO";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variables.scss";

.sebrae {
  display: flex;
  align-items: center;
}

.header-title {
  display: flex;
  align-items: center;
  color: $cor-selo-texto;
  font-weight: bold;
  font-size: 20px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 10px;
}
.medalhas {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 70px;
  }
}
</style>
